// extracted by mini-css-extract-plugin
export default {"companyContainer":"CompanyModal_companyContainer__0BlvM"};